'use client';

import { HomeGenerationFormView } from './HomeGenerationFormView';

export const HomeGenerationForm = () => <HomeGenerationFormView />;
